import Leaflet from 'leaflet';
import 'leaflet/dist/leaflet.css';
import IntersectionObserver from 'intersection-observer-polyfill';
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import AutoComplete from '@tarekraafat/autocomplete.js';
import '@tarekraafat/autocomplete.js/dist/css/autoComplete.css';

fixLeafletIcons();

document.addEventListener('DOMContentLoaded', initMaps);

function initMaps() {
	// initialize map
	let map = null;
	let mapEls = document.querySelectorAll('[data-map]');

	mapEls.forEach(mapEl => {
		let observer = new IntersectionObserver((entries, observ) => {
			entries.map(entry => {
				if(mapEl.isSameNode(entry.target) && entry.isIntersecting) {
					initMap(mapEl)
				}
			});
		}, {
			rootMargin: '200px 200px 200px 200px',
			threshold: [0, 0, 0, 0, 0]
		});

		observer.observe(mapEl);
	});
}

function initMap(mapEl) {
	const lat = +mapEl.dataset.lat;
	const lng = +mapEl.dataset.lng;
	const mapId = mapEl.dataset.map;
	const zoom = mapEl.dataset.zoom || 12;

	// find markers inside map
	const markerEls = mapEl.querySelectorAll('[data-marker]');

	const map = Leaflet.map(mapEl, {
    center: [lat, lng],
    zoom: zoom
	});

	Leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
		maxZoom: 19,
		attribution: '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a>'
	}).addTo(map);

	// add markers
	map.markers = [];
	const markers = {};
	for(let i = 0; i < markerEls.length; i++) {
		const marker = addMarker(markerEls[i], map);

		// add marker to array
		markers[markerEls[i].dataset.marker] = marker;
		map.markers.push(marker);
	}

	initMapAutocompletes(mapId, markers, map);

	return map;	
}

function addMarker(markerEl, map) {
	const lat = +markerEl.dataset.lat;
	const lng = +markerEl.dataset.lng;
	const draggable = markerEl.hasAttribute('data-draggable');
	const clickMove = markerEl.hasAttribute('data-click-move');

	const marker = Leaflet.marker({ lat: lat, lon: lng }, { draggable });
	map.addLayer(marker);

	// increase marker icon size
	var icon = marker.options.icon;
	icon.options.iconSize = [32, 44];
	marker.setIcon(icon);

	if(clickMove) {
		map.on('click', event => updateMarkerPosition(markerEl.dataset.marker, marker, event.latlng.lat, event.latlng.lng, draggable));
	}

	if(draggable) {
		marker.on('dragend', event => {
			const position = marker.getLatLng();
	
			updateMarkerPosition(markerEl.dataset.marker, marker, position.lat, position.lng);
		});
	}

	if(markerEl.innerHTML) marker.bindPopup(marker.innerHTML);

	return marker;
}

function updateMarkerPosition(markerId, marker, lat, lng, draggable) {
	marker.setLatLng(new Leaflet.LatLng(lat, lng), { draggable });

	const latInputEls = document.querySelectorAll(`[data-marker-lat="${markerId}"]`);
	const lngInputEls = document.querySelectorAll(`[data-marker-lng="${markerId}"]`);

	if(latInputEls.length) latInputEls.forEach(el => el.value = lat);
	if(lngInputEls.length) lngInputEls.forEach(el => el.value = lng);
}

function updateStreet(mapId, street) {
	const streetInputEls = document.querySelectorAll(`[data-autocomplete-street="${mapId}"]`);
	if(streetInputEls.length) streetInputEls.forEach(el => el.value = street);
}

function initMapAutocompletes(mapId, markers, map) {
	const inputEls = $('input[data-autocomplete-map="' + mapId + '"]');
	for(let i = 0; i < inputEls.length; i++){
		const inputEl = inputEls[i];

		// get connected marker
		const marker = markers[inputEl.dataset.autocompleteMarker];

		initAutocomplete(mapId, inputEl, inputEl.dataset.autocompleteMarker, marker, map);
	}
}

function initAutocomplete(mapId, inputEl, markerId, marker, map) {
	const provider = new OpenStreetMapProvider({
		params: {
			'accept-language': 'ua',
			countrycodes: 'ua',
			addressdetails: true
		}
	});

	const autocomplete = new AutoComplete({
		selector: () => inputEl,
		placeHolder: "Введите адрес",
		data: {
			src: async (query) => {
				const results = await provider.search({ query: inputEl.value });

				return results;
			}
		},
		keys: ['label'],
		resultItem: {
			element: (item, data) => {
				const address = data.value.raw.address;
				let html = '';

				const parts = [
					address.city,
					address.quarter,
					address.borough,
					address.neighbourhood,
					address.railway || address.road
				];

				parts.forEach((part, index) => {
					if(!part) return;

					html += part;

					if(index + 1 !== parts.length) html += ', ';
					else html += ' ';
				});

				if(address.house_number) html += address.house_number + ' ';

				item.innerHTML = html;

				item.onclick = () => {
					map.flyTo(new L.LatLng(data.value.y, data.value.x));

					updateMarkerPosition(markerId, marker, data.value.y, data.value.x, true);

					updateStreet(mapId, html);
					inputEl.value = html;
				}
			},
			highlight: {
				render: true
			}
		},
		debounce: 300,
		searchEngine: (item, record) => record
	});
}

function fixLeafletIcons() {
	delete Leaflet.Icon.Default.prototype._getIconUrl;

	Leaflet.Icon.Default.mergeOptions({
		iconRetinaUrl: '/wp-content/themes/viprealty/assets/images/marker.png',
		iconUrl: '/wp-content/themes/viprealty/assets/images/marker.png',
		shadowUrl: ''
	});
}